import { useState } from "react";
import RadioCardGroup from "../shared/RadioCardGroup";
import YearSelect from "../shared/YearSelect";
import StepNavigation from "../shared/StepNavigation";
import { FoerderFormData } from "./FoerderRechner";

interface Props {
  data: FoerderFormData;
  onChange: (data: Partial<FoerderFormData>) => void;
  onNext: () => void;
}

export default function Step1Gebaeude({ data, onChange, onNext }: Props) {
  const [errors, setErrors] = useState<{ gebaeudetyp?: string; baujahr?: string }>({});

  const validate = () => {
    const e: typeof errors = {};
    if (!data.gebaeudetyp) e.gebaeudetyp = "Bitte Gebäudetyp auswählen.";
    if (!data.baujahr) e.baujahr = "Bitte Baujahr wählen.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  return (
    <div className="animate-slide-up" data-testid="step-1-gebaeude">
      <RadioCardGroup
        label="Gebäudetyp"
        options={[
          { value: "efh", label: "Einfamilienhaus", description: "Freistehendes Haus, Doppelhaus, Reihenhaus" },
          { value: "mfh", label: "Mehrfamilienhaus", description: "Gebäude mit 3 oder mehr Wohneinheiten" },
          { value: "wohnung", label: "Eigentumswohnung", description: "Wohnung in einem Mehrfamilienhaus" },
        ]}
        value={data.gebaeudetyp}
        onChange={(v) => onChange({ gebaeudetyp: v })}
        error={errors.gebaeudetyp}
        testId="gebaeudetyp-group"
      />

      <YearSelect
        label="Baujahr des Gebäudes"
        value={data.baujahr}
        onChange={(y) => onChange({ baujahr: y })}
        error={errors.baujahr}
        hint="Je älter das Gebäude, desto höher die mögliche Förderung."
      />

      <StepNavigation onNext={() => { if (validate()) onNext(); }} nextLabel="Zur Maßnahme" />
    </div>
  );
}
